import { SwarmPlotCustomLayerProps } from '@nivo/swarmplot'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { entries, groupBy, maxBy, minBy } from 'lodash'
import { ComparisonDatum } from 'ComponentLibrary/src/molecules/ComparisonChart/types'

export const ComparisonChartRange = ({ nodes }: SwarmPlotCustomLayerProps<ComparisonDatum>) => {
    const findMinX = (nodes: { x: number }[]) => minBy(nodes, 'x')?.x || 0
    const findMaxX = (nodes: { x: number }[]) => maxBy(nodes, 'x')?.x || 0
    const nodesByGroup = groupBy(nodes, (node) => node.data.group)

    return entries(nodesByGroup).map(([groupKey, nodesInGroup]) =>
        nodesInGroup.length > 1 ? (
            <rect
                key={groupKey}
                x={findMinX(nodesInGroup)}
                y={nodesInGroup[0].y - 17}
                width={findMaxX(nodesInGroup) - findMinX(nodesInGroup)}
                height={7}
                rx={tokens.SizingCornerS}
                fill={tokens.ColorGraphNeutralLightest}
            />
        ) : null
    )
}
